import image1 from "../assets/img/portfolio/portfolio-1.jpg";
import image2 from "../assets/img/portfolio/portfolio-2.jpg";
import image3 from "../assets/img/portfolio/portfolio-3.jpg";
import image4 from "../assets/img/portfolio/portfolio-4.jpg";
import image5 from "../assets/img/portfolio/portfolio-5.jpg";
import whoweare from "../assets/img/page/who-we-are.jpg";
import image7 from "../assets/img/portfolio/portfolio-7.jpg";
import image8 from "../assets/img/portfolio/portfolio-8.jpg";
import image6 from "../assets/img/portfolio/portfolio-6.jpg";
import image9 from "../assets/img/portfolio/portfolio-9.jpg";
import image10 from "../assets/img/portfolio/portfolio-10.jpg";
import image11 from "../assets/img/portfolio/portfolio-11.jpg";
import image12 from "../assets/img/portfolio/portfolio-12.jpg";
import image13 from "../assets/img/portfolio/portfolio-13.jpg";
import image14 from "../assets/img/portfolio/portfolio-14.jpg";
import image15 from "../assets/img/portfolio/portfolio-15.jpg";
import image16 from "../assets/img/portfolio/portfolio-16.jpg";
import image17 from "../assets/img/portfolio/portfolio-17.jpg";
import image18 from "../assets/img/portfolio/portfolio-18.jpg";
import image19 from "../assets/img/portfolio/portfolio-19.jpg";
import imageBanner from "../assets/img/banner/banner-2.jpg";

const portfolioData = [
    {        
        id: 'border-road-project',
        title: '1,036km border road project ',
        subtitle: 'Consultancy',
        image: image1,
        category: "consultancy",
    },
    {        
        id: 'housing-project',
        title: "World's largest housing project",
        subtitle: 'Consultancy',
        image: image2,
        category: "consultancy",
    },
    {        
        id: 'three-star-hotel',
        title: '3 star hotel',
        subtitle: 'Architecture',
        image: image3,
        category: "architecture",
    },
    {        
        id: 'residential-complex',
        title: 'Building in Basundhara',
        subtitle: 'Architecture',
        image: image4,
        category: "architecture",
    },
    {        
        id: 'residential-building',
        title: 'Building in Jalshiri',
        subtitle: 'Architecture',
        image: image5,
        category: "architecture",
    },
    {        
        id: 'market-complex',
        title: 'Market Complex Building',
        subtitle: 'Architecture',
        image: image6,
        category: "architecture",
    },
    {        
        id: 'teknaf-road',
        title: 'Teknaf Merine Drive Road',
        subtitle: 'construction',
        image: image7,
        category: "construction",
    },
    {
        id: 'canals-chattogram',
        title: 'Canals in Chattogram City',
        subtitle: 'Construction',
        image: image8,
        category: "Construction",
    },
    {
        id: 'flood-control',
        title: 'Flood Control and Drainage Improvement',
        subtitle: 'Construction',
        image: image9,
        category: "construction",
    },
    {
        id: 'sea-view1',
        title: 'Sea View Resort',
        subtitle: 'Renovation',
        image: imageBanner,
        category: "architecture",
    },
    {
        id: 'construction-of-building',
        title: 'Building',
        subtitle: 'Construction',
        image: image10,
        category: "construction",
    },
    {
        id: 'sea-view2',
        title: 'Factory Building',
        subtitle: 'Engineering',
        image: image11,
        category: "engineering",
    },
    {
        id: 'construction-of-building',
        title: 'Steel Structure Building',
        subtitle: 'Engineering',
        image: image12,
        category: "engineering",
    },
    {
        id: 'hill-tracks',
        title: 'Hill Tracks',
        subtitle: 'Construction',
        image: image13,
        category: "construction",
    },
    {
        id: 'hill-tracks',
        title: 'Flood control project',
        subtitle: 'Construction',
        image: image14,
        category: "construction",
    },
    {
        id: 'construction-of-building',
        title: 'Deep Foundation',
        subtitle: 'Construction',
        image: image15,
        category: "construction",
    },
    {
        id: 'canal-construction',
        title: 'Canal Construction',
        subtitle: 'Construction',
        image: image16,
        category: "construction",
    },
    {
        id: 'soil-test',
        title: 'Flood Control Project',
        subtitle: 'Construction',
        image: image17,
        category: "construction",
    },
    {
        id: 'floor-plans',
        title: 'Floor plans',
        subtitle: 'Architecture',
        image: image18,
        category: "architecture",
    },
    {
        id: 'duplex',
        title: 'Duplex',
        subtitle: 'Architecture',
        image: image19,
        category: "architecture",
    },
];

export default portfolioData;
